(() => {

    const hydrateDeferredMedia = () => {
      const root = document;
      const deferredMedia = root.querySelectorAll('img[data-src], img[data-srcset], source[data-src], source[data-srcset]');
      if (!deferredMedia.length) {
        return;
      }

      deferredMedia.forEach((element) => {
        const dataSrcset = element.getAttribute('data-srcset');
        if (dataSrcset != null) {
          element.setAttribute('srcset', dataSrcset);
          element.removeAttribute('data-srcset');
        }

        const dataSrc = element.getAttribute('data-src');
        if (dataSrc != null) {
          element.setAttribute('src', dataSrc);
          element.removeAttribute('data-src');
        }
      });
    };

    const loadCustomScripts = () => {
        window.custom_scripts.forEach(script => {
            let s = document.createElement('script');
            s.setAttribute('src', script);
            document.head.insertAdjacentElement("beforeend", s);
        });
    };

    const loadBingUET = () => {
      (function (w, d, t, r, u) {
        var f, n, i;
        (w[u] = w[u] || []),
          (f = function () {
            var o = { ti: '56297450' };
            (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
          }),
          (n = d.createElement(t)),
          (n.src = r),
          (n.async = 1),
          (n.onload = n.onreadystatechange =
            function () {
              var s = this.readyState;
              (s && s !== 'loaded' && s !== 'complete') || (f(), (n.onload = n.onreadystatechange = null));
            }),
          (i = d.getElementsByTagName(t)[0]),
          i.parentNode.insertBefore(n, i);
      })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
    };

    const loadClarity = () => {
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "opte3jlu0j");
    }

    const loadLinkedInInsight = () => {
      _linkedin_partner_id = '7565058';
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      (function (l) {
        if (!l) {
          window.lintrk = function (a, b) {
            window.lintrk.q.push([a, b]);
          };
          window.lintrk.q = [];
        }
        var s = document.getElementsByTagName('script')[0];
        var b = document.createElement('script');
        b.type = 'text/javascript';
        b.async = true;
        b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
        s.parentNode.insertBefore(b, s);
      })(window.lintrk);
    }

    const loadMinMaxify = () => {
      let s = document.createElement('script');
      s.setAttribute('src', 'https://limits.minmaxify.com/tileboom.myshopify.com?v=200&r=20231019171051&shop=tileboom.myshopify.com');
      document.head.insertAdjacentElement("beforeend", s);
    }

    const loadKlaviyo = () => {
      let s = document.createElement('script');
      s.setAttribute('src', 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=T5VFJc');
      s.async = true;
      document.head.insertAdjacentElement("beforeend", s);
    }

    const loadFormBuilderHelper = () => {
        const script = document.createElement('script');
        script.src = "https://ecf.cirkleinc.com/public/frontend/js/form-builder-helper.js";
        script.async = true;
        document.head.insertAdjacentElement("beforeend", script);
    };

    const loadHubspot = () => {
      let s = document.createElement('script');
      s.setAttribute('id', 'hs-script-loader');
      s.setAttribute('src', 'https://js.hs-scripts.com/39823395.js');
      s.defer = true;
      document.head.insertAdjacentElement("beforeend", s);
    }

    const loadReviewsIO = () => {
      // Inject Reviews.io CSS
      let link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = "https://widget.reviews.io/rating-snippet/dist.css";
      document.head.appendChild(link);

      // Product Card Reviews
      const a = document.createElement('script');
      a.src = 'https://widget.reviews.io/rating-snippet/dist.js';
      document.head.insertAdjacentElement("beforeend", a);
      a.onload = function () {
        ratingSnippet("ruk_rating_snippet", {
          store: "tileclub.com",
          mode: 'minimal',
          color: "#c9921f",
          textClr: '#2b2624',
          linebreak: false,
          text: " ",
          singularText: " ",
          lang: "en",
          usePolaris: true,
          showEmptyStars: false,
          showNumericalAverageRating: true,
        });
      };

      // Rating Bar Reviews HP and PLP
      const widget = document.querySelector(".reviews-io-rating-bar-widget");
      if (widget) {
        (function () {
          const OriginalRO = window.ResizeObserver;

          window.ResizeObserver = class extends OriginalRO {
            constructor(callback) {
              super((entries, observer) => {
                entries.forEach(e => {
                  if (
                    e.target.classList.contains('RatingBarWidget') &&
                    e.target.classList.contains('R-isLoaded')
                  ) {
                    requestAnimationFrame(() => callback([e], observer));
                  } else {
                    callback([e], observer);
                  }
                });
              });
            }
          };
        })();
        widget.setAttribute("data-store-name",'tileboom.myshopify.com');
        widget.setAttribute("lang",'en');
        let ratingBarScript = document.createElement("script");
        ratingBarScript.setAttribute("src", "//widget.reviews.io/modern-widgets/rating-bar.js");
        document.body.appendChild(ratingBarScript);
      }
    }


    const loadScripts = () => {
      hydrateDeferredMedia(document);
        loadCustomScripts();
        requestAnimationFrame(loadReviewsIO);
        loadKlaviyo();
        loadClarity();
        loadLinkedInInsight();
        loadBingUET();
        loadHubspot();
        loadMinMaxify();
        loadFormBuilderHelper();
    }
    document.addEventListener('UserInteracted', loadScripts, false);
})();